import { pointerIntersection } from "@dnd-kit/collision";
import { useDroppable } from "@dnd-kit/react";

import {
  ITEM_MOVE_DRAG_TYPE,
  TAG_ADD_DROP_TYPE,
  isItemMoveDragData,
  type TagAddDropData,
} from "../item-move-dnd";

interface UseTagAddDropTargetOptions {
  tagId: string;
  tagName: string;
  disabled?: boolean;
}

export function useTagAddDropTarget({
  tagId,
  tagName,
  disabled = false,
}: UseTagAddDropTargetOptions) {
  return useDroppable<TagAddDropData>({
    id: `${TAG_ADD_DROP_TYPE}:${tagId}`,
    type: TAG_ADD_DROP_TYPE,
    collisionDetector: pointerIntersection,
    disabled,
    data: {
      kind: TAG_ADD_DROP_TYPE,
      tagId,
      tagName,
    },
    accept: (source) => {
      if (source.type !== ITEM_MOVE_DRAG_TYPE || !isItemMoveDragData(source.data)) {
        return false;
      }

      return source.data.items.some((item) => !item.tagIds.includes(tagId));
    },
  });
}
